<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
    :no-close-on-backdrop="preventClose"
    content-class="!rounded-[8px]"
    :dialog-class="['sm:!max-w-[600px]', dialogClass]"
    modal-class="!overflow-auto"
    centered
    @hidden="$emit('hidden')"
    @shown="$emit('shown')"
  >
    <slot />
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
    dialogClass: {
      type: String,
      default: '',
    },
  },
}
</script>
